import { render, staticRenderFns } from "./AAddDomainModal.vue?vue&type=template&id=7d82d6dc&"
import script from "./AAddDomainModal.vue?vue&type=script&lang=js&"
export * from "./AAddDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports